<div class="mat-dialog-footage-download">
    <div mat-dialog-title class="dialog-title">
        <h2 class="title-name">{{headerName}}
            <span>
                {{potentialName}} - {{potentialId}}
                <!-- <strong>Cameras for site : </strong> -->
            </span>
        </h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="footage-download-page">
        <div class="footage-section">
            <div class="font_white">
                <!-- <h4 class="heading_text">Footage Download</h4> -->
                <div class="form-section">
                    <mat-grid-list cols="1" rowHeight="80px">
                        <mat-grid-tile>
                            <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                    <mat-label class="">Camera Name </mat-label>
                                    <mat-select name="selectedCamera" [(ngModel)]="selectedCamera"
                                        (ngModelChange)="handleSelectCamera($event)"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let camera of cameraLists;"
                                            [value]="camera">{{camera.cameraName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>
                        <!-- <mat-grid-tile>
                            <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                    <mat-label class="">Format </mat-label>
                                    <mat-select name="selectedFormat" [(ngModel)]="selectedFormat"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let format of formatList;"
                                            value="{{format.value}}">{{format.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile> -->
                        <mat-grid-tile>
                            <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                    <mat-label class="">Download Footage Type </mat-label>
                                    <mat-select name="selectedDownloadFootageType"
                                        [(ngModel)]="selectedDownloadFootageType" [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let downloadFootage of downloadFootageTypeList;"
                                            value="{{downloadFootage.value}}">{{downloadFootage.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>
                        <mat-grid-tile>
                            <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                    <mat-label class="">Start Date Time </mat-label>
                                    <input matInput readonly [owlDateTimeTrigger]="picker1"
                                        placeholder="Start Date Time" [min]="minStartDate" [max]="maxStart"
                                        [(ngModel)]="startDateTime" (dateChange)="selectStartDate($event)"
                                        (ngModelChange)="dataTimeChange($event)" autocomplete="off">
                                    <mat-datepicker-toggle matSuffix [for]="$any(picker1)"></mat-datepicker-toggle>
                                    <owl-date-time #picker1>
                                    </owl-date-time>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>
                        <mat-grid-tile>
                            <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                    <mat-label class="">End Date Time</mat-label>
                                    <input matInput readonly [owlDateTimeTrigger]="picker2"
                                        placeholder="End Date Time" [min]="minEndDate" [max]="maxEnd"
                                        [(ngModel)]="endDateTime" (dateChange)="selectEndDate($event)"
                                        autocomplete="off">
                                    <mat-datepicker-toggle matSuffix [for]="$any(picker2)"></mat-datepicker-toggle>
                                    <owl-date-time #picker2>
                                    </owl-date-time>
                                </mat-form-field>
                                <mat-error class="error-datetime"
                                    *ngIf="showTimeRangeError !== ''">{{showTimeRangeError}}</mat-error>
                                <mat-error class="error-datetime" *ngIf="show12HrLimitMessage">End date cannot exceed 12
                                    hours from start date.</mat-error>
                            </div>
                        </mat-grid-tile>
                    </mat-grid-list>
                    <div class="download-btn-area">
                        <button mat-raised-button class="download_btn" (click)="handleDownload()"
                            [disabled]="!(selectedCamera && selectedDownloadFootageType && startDateTime &&endDateTime && !show12HrLimitMessage)">
                            Queue Download</button>

                            <!---Instant Download-->
                            <button mat-raised-button class="instant_download_btn" 
                            (click)="handleInstantDownload()" [disabled]="!(selectedCamera && selectedDownloadFootageType && startDateTime &&endDateTime && !show12HrLimitMessage)">
                                Instant Download</button>
                    </div>
                    <h3 *ngIf="requestPlacedSuccessfully" class="request">Request placed successfully</h3>
                </div>
            </div>
        </div>
    </mat-dialog-content>